import React, { useState } from 'react'
import type { UpdateTask } from 'api/generated'
import useDialogState from 'hooks/use-dialog-state'

type TasksDialogType =
  | 'create'
  | 'update'
  | 'delete'
  | 'import'
  | 'run'
  | 'run-no-mail'
  | 'rerun'
  | 'rerun-no-mail'
  | 'details'
  | 'restart-server'
  | 'clean-cache'
  | 'flush-cache'

interface TasksContextType {
  open: TasksDialogType | null
  setOpen: (str: TasksDialogType | null) => void
  currentRow: UpdateTask | null
  setCurrentRow: React.Dispatch<React.SetStateAction<UpdateTask | null>>
}

const TasksContext = React.createContext<TasksContextType | null>(null)

interface Props {
  children: React.ReactNode
}

export default function TasksProvider({ children }: Props) {
  const [open, setOpen] = useDialogState<TasksDialogType>(null)
  const [currentRow, setCurrentRow] = useState<UpdateTask | null>(null)
  return (
    <TasksContext value={{ open, setOpen, currentRow, setCurrentRow }}>
      {children}
    </TasksContext>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export const useTasks = () => {
  const tasksContext = React.useContext(TasksContext)

  if (!tasksContext) {
    throw new Error('useTasks has to be used within <TasksContext>')
  }

  return tasksContext
}
